export default __webpack_public_path__ + "assets/models/c66f965c2f8aae5686a63285b13b2a3b.glb";